import React from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import './ReflectAndIntegrate3.scss';

export default function ReflectAndIntegrate3({ apiData, previewData, reportType, pageNumber }) {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)",}}>
      <HeaderPreview apiData={apiData} />
     <div style={{ padding: '16px 0px', display: 'flex', justifyContent: 'left', alignItems: 'left', }}>
        <div>
          <h2
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontStyle: 'normal',
              fontSize: '14px',
              lineHeight: '18px',
              letterSpacing: '0px',
              color: '#00577D',
              textTransform: 'uppercase',
              marginBottom: '16px',
              marginTop: 0,
            }}
          >
            LEADERSHIP INTEGRATION
          </h2>
          <p style={{
            fontFamily: 'Helvetica, sans-serif',
            fontWeight: 400,
            fontSize: '10px',
            lineHeight: '14px',
            color: '#000000',
            letterSpacing: 0,
          }} >Use these 12 quadrant-based questions to deepen your professional insight, coaching conversations, or journaling practice. Focus on one quadrant—or explore them all.</p>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            COLLABORATIVE – Culture, Relationships, Team Dynamics
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px" }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What do your results reveal about how you build trust and connection with others?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>How does your leadership shape the relational culture of your team or organization?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where could collaboration improve through clearer expectations or emotional presence?</li>
          </ol>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            VISIONARY – Purpose, Perspective, Meaning
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px"  }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What long-term vision or mission is clarified or challenged by your assessment results?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>How aligned are your current leadership decisions with what matters most to you?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where could a fresh perspective or purpose improve your leadership?</li>
          </ol>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            STRATEGIC – Thinking, Planning, Decision-Making
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside",margin: "8px 0px 16px"  }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What patterns in your results highlight gaps or strengths in strategic thinking?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where could stronger planning or structure improve your leadership?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What decisions are overdue—and how can you approach them with greater clarity?</li>
          </ol>
          <h3
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 700,
              fontSize: '10px',
              lineHeight: '14px',
              color: '#000000',
              letterSpacing: 0,
              margin: "0px"
            }}
          >
            PERFORMANCE – Execution, Accountability, Results
          </h3>
          <ol style={{ paddingLeft: '0', listStylePosition: "inside", margin: "8px 0px 16px"  }}>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What action steps will you take based on key leadership insights from your results?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>Where do you need to increase ownership, discipline, or consistency in your leadership?</li>
            <li style={{ fontFamily: 'Helvetica, sans-serif', fontWeight: 400, fontSize: '10px', lineHeight: '14px', color: '#000000', marginBottom: '4px' }}>What measurable outcome will you commit to in the next 30 days?</li>
          </ol>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
